var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"BaseDropItem",staticClass:"position-relative"},[_vm._t("button",null,{"onClick":_setup.onButtonClick}),(_setup.showDropdown)?_c('div',{staticClass:"position-absolute",class:{
      'top-full end-0': _setup.props.direction === 'BOTTOM',
      'top-0 end-full': _setup.props.direction === 'LEFT',
      'top-full start-0': _setup.props.direction === 'BOTTOM_LEFT',
      '': _setup.props.direction === 'CUSTOM',
    },staticStyle:{"z-index":"10","min-width":"max-content"}},[_vm._t("item",null,{"onClick":_setup.onMenuClick})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }